import React, { useState, useEffect } from 'react';
import { SUPABASE_URL, SUPABASE_ANON_KEY, supabase } from '../supabaseClient';
import SongMaker from './SongMaker';

const UI_TR = {
  ru: { story: 'История', synonyms: 'Синонимы', antonyms: 'Антонимы', root: 'Корень', phonetic: 'Похожие по звучанию', comparison: 'Степени сравнения', pos: 'Часть речи', etymology: 'Этимология', updated: 'Обновлено', copyLink: 'Копировать ссылку', copied: 'Ссылка скопирована ✓', translating: 'Перевод…', created: 'Создано', customer: 'Заказчик', performer: 'Исполнитель', customerPerformer: 'Заказчик и исполнитель', viewOne: 'просмотр', viewMany: 'просмотров', longVersion: 'Длинная версия', shortVersion: 'Короткая версия', yourVersion: 'Ваша версия', searchPlaceholder: 'Поиск слова…', recentSearches: 'Недавние поиски', needLogin: 'Это слово создано в русской версии. Чтобы увидеть его на выбранном языке, войди в программу.' },
  en: { story: 'Story', synonyms: 'Synonyms', antonyms: 'Antonyms', root: 'Root', phonetic: 'Similar sounding', comparison: 'Comparison', pos: 'Part of speech', etymology: 'Etymology', updated: 'Updated', copyLink: 'Copy link', copied: 'Link copied ✓', translating: 'Translating…', created: 'Created', customer: 'Customer', performer: 'Performer', customerPerformer: 'Customer and performer', viewOne: 'view', viewMany: 'views', longVersion: 'Long version', shortVersion: 'Short version', yourVersion: 'Your version', searchPlaceholder: 'Search word…', recentSearches: 'Recent searches', needLogin: 'This word was created in the Russian version. To see it in your language, sign in to the program.' },
  uk: { story: 'Історія', synonyms: 'Синоніми', antonyms: 'Антоніми', root: 'Корінь', phonetic: 'Схожі за звучанням', comparison: 'Ступені порівняння', pos: 'Частина мови', etymology: 'Етимологія', updated: 'Оновлено', copyLink: 'Копіювати посилання', copied: 'Посилання скопійовано ✓', translating: 'Переклад…', created: 'Створено', customer: 'Замовник', performer: 'Виконавець', customerPerformer: 'Замовник і виконавець', viewOne: 'перегляд', viewMany: 'переглядів', longVersion: 'Довга версія', shortVersion: 'Коротка версія', yourVersion: 'Твоя версія', searchPlaceholder: 'Пошук слова…', recentSearches: 'Нещодавні пошуки', needLogin: 'Це слово створено в російській версії. Щоб побачити його твоєю мовою, увійди до програми.' },
  de: { story: 'Geschichte', synonyms: 'Synonyme', antonyms: 'Antonyme', root: 'Wurzel', phonetic: 'Ähnlich klingend', comparison: 'Steigerung', pos: 'Wortart', etymology: 'Etymologie', updated: 'Aktualisiert', copyLink: 'Link kopieren', copied: 'Link kopiert ✓', translating: 'Übersetzen…', created: 'Erstellt', customer: 'Auftraggeber', performer: 'Interpret', customerPerformer: 'Auftraggeber und Interpret', viewOne: 'Aufruf', viewMany: 'Aufrufe', longVersion: 'Lange Version', shortVersion: 'Kurze Version', yourVersion: 'Deine Version', searchPlaceholder: 'Wort suchen…', recentSearches: 'Letzte Suchen', needLogin: 'Dieses Wort wurde in der russischen Version erstellt. Um es in deiner Sprache zu sehen, melde dich im Programm an.' },
  es: { story: 'Historia', synonyms: 'Sinónimos', antonyms: 'Antónimos', root: 'Raíz', phonetic: 'Sonido similar', comparison: 'Comparación', pos: 'Categoría', etymology: 'Etimología', updated: 'Actualizado', copyLink: 'Copiar enlace', copied: 'Enlace copiado ✓', translating: 'Traduciendo…', created: 'Creado', customer: 'Cliente', performer: 'Intérprete', customerPerformer: 'Cliente e intérprete', viewOne: 'vista', viewMany: 'vistas', longVersion: 'Versión larga', shortVersion: 'Versión corta', yourVersion: 'Tu versión', searchPlaceholder: 'Buscar palabra…', recentSearches: 'Búsquedas recientes', needLogin: 'Esta palabra fue creada en la versión rusa. Para verla en tu idioma, inicia sesión en el programa.' },
  fr: { story: 'Histoire', synonyms: 'Synonymes', antonyms: 'Antonymes', root: 'Racine', phonetic: 'Sons similaires', comparison: 'Comparaison', pos: 'Nature du mot', etymology: 'Étymologie', updated: 'Mis à jour', copyLink: 'Copier le lien', copied: 'Lien copié ✓', translating: 'Traduction…', created: 'Créé', customer: 'Client', performer: 'Interprète', customerPerformer: 'Client et interprète', viewOne: 'vue', viewMany: 'vues', longVersion: 'Version longue', shortVersion: 'Version courte', yourVersion: 'Ta version', searchPlaceholder: 'Rechercher un mot…', recentSearches: 'Recherches récentes', needLogin: 'Ce mot a été créé dans la version russe. Pour le voir dans ta langue, connecte-toi au programme.' },
  no: { story: 'Historie', synonyms: 'Synonymer', antonyms: 'Antonymer', root: 'Rot', phonetic: 'Lignende lyd', comparison: 'Gradbøying', pos: 'Ordklasse', etymology: 'Etymologi', updated: 'Oppdatert', copyLink: 'Kopier lenke', copied: 'Lenke kopiert ✓', translating: 'Oversetter…', created: 'Opprettet', customer: 'Bestiller', performer: 'Utøver', customerPerformer: 'Bestiller og utøver', viewOne: 'visning', viewMany: 'visninger', longVersion: 'Lang versjon', shortVersion: 'Kort versjon', yourVersion: 'Din versjon', searchPlaceholder: 'Søk ord…', recentSearches: 'Nylige søk', needLogin: 'Dette ordet ble laget i den russiske versjonen. Logg inn for å se det på ditt språk.' },
};

const PUB_URL = SUPABASE_URL + '/rest/v1/ordskjonnhet_public';

const GENDER_COLORS = { en: '#2563eb', ei: '#be185d', et: '#475569' };
const POS_LABEL = { noun: 'Substantiv', verb: 'Verb', adjective: 'Adjektiv', adverb: 'Adverb' };

function boldNo(text) {
  if (!text) return text;
  const parts = String(text).split(/([A-Za-z\u00C0-\u017F][A-Za-z\u00C0-\u017F'\u2019-]*)/);
  let k = 0;
  return parts.map((p) => (/^[A-Za-z\u00C0-\u017F]/.test(p)
    ? <strong key={k++} className="ord-pv-no">{p}</strong>
    : <span key={k++}>{p}</span>));
}

function renderPhrase(phrase, headword, color, forms, boldAll) {
  if (!phrase) return phrase;
  const clean = (s) => String(s || '').trim().toLowerCase().replace(/^(en|ei|et|\u00e5)\s+/i, '');
  const stem = clean(headword);
  if (!stem) return phrase;
  const stemWords = stem.split(/\s+/).filter((w) => w.length > 1);
  const exact = new Set([stem, ...stemWords, ...((Array.isArray(forms) ? forms : []).map(clean))].filter(Boolean));
  const parts = String(phrase).split(/([A-Za-zÀ-ÿ]+)/);
  let k = 0;
  return parts.map((p) => {
    const low = p.toLowerCase();
    const isWord = /[A-Za-zÀ-ÿ]/.test(p);
    const hit = isWord && (exact.has(low) || stemWords.some((sw) => low.startsWith(sw)));
    return hit
      ? <mark key={k++} style={{ color, background: 'transparent', fontWeight: 700 }}>{p}</mark>
      : (boldAll && isWord ? <strong key={k++} className="ord-pv-no">{p}</strong> : <span key={k++}>{p}</span>);
  });
}

function speakNorwegian(text, rate) {
  const t = String(text || '').trim();
  if (!t) return;
  try { const a = new Audio('/tts/synth?text=' + encodeURIComponent(t) + (rate ? '&rate=' + rate : '')); a.play().catch(() => {}); } catch (e) {}
}

function stripLeadingArticle(text) {
  return String(text || '').replace(/^\s*(en|ei|et|\u00e5)\s+/i, '').trim();
}

const arr = (v) => (Array.isArray(v) ? v : []);
function isComparisonForm(form, base) {
  const f = String(form || '').trim().toLowerCase();
  const b = String(base || '').trim().toLowerCase();
  if (!f || f === b) return false;
  // Надёжные окончания степеней сравнения: -ere (сравнит.), -est/-este (превосх.).
  // Обычные формы мн./опред. оканчиваются на одиночное -e (store, slemme) и сюда не попадают.
  return /(ere|este|est)$/.test(f) && f.length > b.length;
}

function pluralViews(n) {
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return 'просмотр';
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return 'просмотра';
  return 'просмотров';
}

function fallbackCopy(text, done) {
  try {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.focus(); ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    done();
  } catch (e) {}
}

let lastSpinnerOpenedAt = null;
function readCachedVersions(wn) {
  try { const c = localStorage.getItem('ordpub:' + (wn || '')); if (c) { const a = JSON.parse(c); if (Array.isArray(a) && a.length) return a; } } catch (e) {}
  return null;
}
export default function OrdskjonnhetPublic({ supabase, wordNorm, wordText, wordPos, onClose, onOpenWord, seed, openedAt, userProfile, onSongSaved, preferOwnerId, onEvik, evikBusy, onRequestLogin, guestPromptText, loginLabel, uiLang, onLogoReload, searchHistory, addToHistory }) {
  const [versions, setVersions] = useState(() => (seed ? [seed] : readCachedVersions(wordNorm)));
  const [spinnerHold, setSpinnerHold] = useState(() => (openedAt || 0) !== lastSpinnerOpenedAt);
  const [animateOpen] = useState(() => (openedAt || 0) !== lastSpinnerOpenedAt);
  const [idx, setIdx] = useState(0);
  const [err, setErr] = useState('');
  const [linkSet, setLinkSet] = useState(() => new Set());
  const [authToken, setAuthToken] = useState(SUPABASE_ANON_KEY);
  const reqHead = { apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + authToken };
  useEffect(() => {
    let active = true;
    supabase.auth.getSession().then(({ data }) => {
      const t = data && data.session && data.session.access_token;
      if (active && t) setAuthToken(t);
    }).catch(() => {});
    return () => { active = false; };
  }, []);

  const [zoom, setZoom] = useState(false);
  const [fullPhoto, setFullPhoto] = useState(null);
  const [imgReady, setImgReady] = useState(false);
  const [copied, setCopied] = useState(false);
  const [searchQ, setSearchQ] = useState('');
  const [searchFocused, setSearchFocused] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [guestEvikWord, setGuestEvikWord] = useState('');
  const [hideRu, setHideRu] = useState(true);
  const [translated, setTranslated] = useState(null);
  const [translateState, setTranslateState] = useState('idle');
  const trLang = (uiLang && uiLang !== 'ru') ? uiLang : null;
  const trUi = (k) => (UI_TR[uiLang] && UI_TR[uiLang][k]) || UI_TR.ru[k] || k;
  const [viewCount, setViewCount] = useState(null);

  useEffect(() => {
    const q = (searchQ || '').trim();
    if (q.length < 1) { setSearchResults([]); return; }
    let alive = true;
    const t = setTimeout(() => {
      const enc = encodeURIComponent('*' + q + '*');
      const url = PUB_URL + '?select=word_text,word_norm&authored=eq.true&or=(word_text.ilike.' + enc + ',word_norm.ilike.' + enc + ')&limit=8';
      fetch(url, { headers: reqHead, cache: 'no-store' })
        .then((r) => (r.ok ? r.json() : []))
        .then((rows) => { if (alive) setSearchResults(Array.isArray(rows) ? rows : []); })
        .catch(() => { if (alive) setSearchResults([]); });
    }, 250);
    return () => { alive = false; clearTimeout(t); };
  }, [searchQ]);

  useEffect(() => {
    let alive = true;
    setVersions(seed ? [seed] : readCachedVersions(wordNorm)); setIdx(0); setErr('');
    if (!wordNorm) { setVersions(seed ? [seed] : []); return; }
    const SEL = 'id,owner_id,word_norm,word_text,owner_nick,data,completeness,authored,fullness_date,created_at,updated_at';
    const qurl = PUB_URL + '?select=' + SEL + '&word_norm=eq.' + encodeURIComponent(wordNorm) + (wordPos ? '&pos=eq.' + encodeURIComponent(wordPos) : '') + '&authored=eq.true&order=created_at.asc,fullness_date.asc';
    const keep = () => setVersions((prev) => (prev && prev.length ? prev : (seed ? [seed] : [])));
    const ctrl = new AbortController();
    const timer = setTimeout(() => { try { ctrl.abort(); } catch (e) {} }, 12000);
    fetch(qurl, { headers: reqHead, cache: 'no-store', signal: ctrl.signal })
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => {
        if (!alive) return;
        clearTimeout(timer);
        if (Array.isArray(data) && data.length) {
          const sorted = data.slice().sort((a, b) => (String(a.owner_nick||'').trim().toLowerCase()==='evik'?0:1) - (String(b.owner_nick||'').trim().toLowerCase()==='evik'?0:1));
          setVersions(sorted);
          try { localStorage.setItem('ordpub:' + wordNorm, JSON.stringify(sorted)); } catch (e) {}
        } else { keep(); }
      })
      .catch(() => { if (!alive) return; clearTimeout(timer); keep(); setErr('cloud'); });
    return () => { alive = false; clearTimeout(timer); };
  }, [supabase, wordNorm, wordPos, authToken]);

  useEffect(() => {
    const oa = openedAt || 0;
    if (oa === lastSpinnerOpenedAt) { setSpinnerHold(false); return undefined; }
    lastSpinnerOpenedAt = oa;
    setSpinnerHold(true);
    const t = setTimeout(() => setSpinnerHold(false), 450);
    return () => clearTimeout(t);
  }, [openedAt]);

  const cur = versions && versions[idx] ? versions[idx] : null;
  useEffect(() => {
    if (!cur || !cur.id) return undefined;
    const mine = userProfile && cur.owner_id && userProfile.id === cur.owner_id;
    if (!mine) return undefined;
    const cust = cur.data && cur.data.customer;
    if (!cust || cust.avatar) return undefined;
    const myAva = userProfile.photo && userProfile.photo.thumb;
    if (!myAva) return undefined;
    const newData = { ...cur.data, customer: { ...cust, avatar: myAva } };
    try {
      supabase.from('ordskjonnhet_public').update({ data: newData }).eq('id', cur.id).then(() => {}, () => {});
    } catch (e) {}
    return undefined;
  }, [cur && cur.id]);

  const d = cur ? (cur.data || {}) : {};
  const _useTr = !!(trLang && translateState === 'ready' && translated);
  const _trPending = !!(trLang && translateState === 'loading');
  const _guestNoTr = !!(trLang && !_useTr && !(userProfile && userProfile.id));
  const dPhraseTr = _useTr ? translated.phrase_translation : ((_trPending || _guestNoTr) ? '' : d.phraseTranslation);
  const dTranslations = _useTr ? translated.translations : ((_trPending || _guestNoTr) ? [] : d.translations);
  const dExampleTr = _useTr ? (translated.example_translations || []) : ((_trPending || _guestNoTr) ? [] : arr(d.exampleTranslations));
  const dStory = _useTr ? translated.story : ((_trPending || _guestNoTr) ? '' : d.story);
  useEffect(() => {
    if (!trLang || !cur) { setTranslated(null); setTranslateState('idle'); return undefined; }
    const wn = String(cur.word_norm || wordNorm || '').trim().toLowerCase();
    const pos = String((cur.data && cur.data.type) || wordPos || '').trim().toLowerCase();
    const version = String(cur.fullness_date || cur.created_at || '');
    if (!wn) return undefined;
    let cancelled = false;
    setTranslated(null); setTranslateState('loading');
    const createViaServer = () => {
      const dd = cur.data || {};
      const texts = { translations: dd.translations || [], phrase_translation: dd.phraseTranslation || '', example_translations: dd.exampleTranslations || [], story: dd.story || '' };
      const body = JSON.stringify({ word: wn, pos, lang: trLang, version, texts, user: userProfile.id });
      fetch('/api/ai/translate-card', { method: 'POST', headers: { ...reqHead, 'Content-Type': 'application/json' }, body })
        .then((r) => r.json()).then((j2) => {
          if (cancelled) return;
          if (j2 && j2.ok && j2.data) {
            setTranslated(j2.data); setTranslateState('ready');
            supabase.from('ordskjonnhet_translations').upsert({ word_norm: wn, pos, lang: trLang, data: j2.data, version, author_id: userProfile.id }, { onConflict: 'word_norm,pos,lang' }).then(() => {}, () => {});
          } else { setTranslateState('error'); }
        }).catch(() => { if (!cancelled) setTranslateState('error'); });
    };
    supabase.from('ordskjonnhet_translations').select('data,version').eq('word_norm', wn).eq('pos', pos).eq('lang', trLang).limit(1)
      .then(({ data: rows }) => {
        if (cancelled) return;
        const row = Array.isArray(rows) && rows.length ? rows[0] : null;
        if (row && row.data && String(row.version || '') === version) { setTranslated(row.data); setTranslateState('ready'); return; }
        if (userProfile && userProfile.id) { createViaServer(); } else { setTranslateState('need-login'); }
      }, () => { if (!cancelled) { if (userProfile && userProfile.id) createViaServer(); else setTranslateState('need-login'); } });
    return () => { cancelled = true; };
  }, [trLang, cur, userProfile, wordNorm, wordPos]);
  const _isDarkTheme = typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme') === 'dark';
  const _genderColors = { en: '#2563eb', ei: '#be185d', et: _isDarkTheme ? '#93b8cf' : '#475569' };
  const _phraseColor = _isDarkTheme ? '#fb923c' : '#ea580c';
  const _adjColor = _isDarkTheme ? '#d4a373' : '#9c6644';
  const _isAdj = d.type === 'adjective' || d.pos === 'adjective';
  const color = d.type === 'phrase' ? _phraseColor : (_isAdj ? _adjColor : (_genderColors[d.gender] || d.catColor || '#6d28d9'));
  const head = d.text || wordText || wordNorm;

  useEffect(() => {
    const pid = cur && cur.id;
    if (!pid) { setViewCount(null); return undefined; }
    let alive = true;
    fetch(SUPABASE_URL + '/rest/v1/rpc/register_ord_view', {
      method: 'POST',
      headers: { ...reqHead, 'Content-Type': 'application/json' },
      body: JSON.stringify({ p_page_id: pid }),
      cache: 'no-store',
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((n) => { if (alive && typeof n === 'number') setViewCount(n); })
      .catch(() => {});
    return () => { alive = false; };
  }, [cur && cur.id]);

  useEffect(() => {
    if (!preferOwnerId || !Array.isArray(versions) || versions.length < 2) return;
    const i = versions.findIndex((v) => v && String(v.owner_id || '') === String(preferOwnerId));
    if (i > 0) setIdx(i);
  }, [versions, preferOwnerId]);
  useEffect(() => { setFullPhoto(null); setZoom(false); setImgReady(false); }, [idx, versions]);

  const openZoom = () => {
    setZoom(true);
    if (fullPhoto) { setImgReady(true); return; }
    setImgReady(false);
    if (cur && cur._fullPhoto) { setFullPhoto(cur._fullPhoto); return; }
    const dp = cur && cur.data && cur.data.photo;
    if (dp && dp.dataUrl) { setFullPhoto(dp.dataUrl); return; }
    if (cur && cur.id) {
      fetch(PUB_URL + '?select=photo&id=eq.' + encodeURIComponent(cur.id), { headers: reqHead, cache: 'no-store' })
        .then((r) => (r.ok ? r.json() : []))
        .then((rows) => { const ph = rows && rows[0] && rows[0].photo; if (ph) setFullPhoto(ph); })
        .catch(() => {});
    }
  };

  const copyLink = () => {
    const url = window.location.origin + '/s/' + encodeURIComponent(wordNorm || '');
    const done = () => { setCopied(true); window.setTimeout(() => setCopied(false), 2000); };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, () => fallbackCopy(url, done));
        return;
      }
    } catch (e) {}
    fallbackCopy(url, done);
  };

  useEffect(() => {
    if (!cur) { setLinkSet(new Set()); return; }
    const cand = [...arr(d.synonyms), ...arr(d.antonyms), ...arr(d.cognates)]
      .map((s) => String(s || '').trim().toLowerCase()).filter(Boolean);
    const uniq = Array.from(new Set(cand));
    if (uniq.length === 0) { setLinkSet(new Set()); return; }
    let alive = true;
    const inList = '(' + uniq.map((w) => '"' + w.replace(/"/g, '') + '"').join(',') + ')';
    fetch(PUB_URL + '?select=word_norm&authored=eq.true&word_norm=in.' + encodeURIComponent(inList), { headers: reqHead, cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : []))
      .then((rows) => { if (alive) setLinkSet(new Set((rows || []).map((r) => r.word_norm))); })
      .catch(() => {});
    return () => { alive = false; };
  }, [cur]);

  const renderChips = (list) => arr(list).map((s, i) => {
    const norm = String(s || '').trim().toLowerCase();
    if (norm && linkSet.has(norm) && onOpenWord) {
      return <button key={i} type="button" className="ord-pv-word-chip ord-pv-link" onClick={() => onOpenWord(s)}>{s}</button>;
    }
    return <span key={i} className="ord-pv-word-chip">{s}</span>;
  });

  return (
    <div className={"ord-public" + (animateOpen ? " ord-anim-page" : "")}>
      <header className="ord-public-head">
        <div className="ord-public-head-inner">
          <div className="app-brand ord-public-brand" role="button" onClick={onLogoReload || onClose}>
            <img className="app-brand-logo" src="/norsk-logo.png" alt="" />
            <div className="app-brand-copy"><h1>Norsk Pro</h1><p><span className="slogan-w1">Enkelt</span> · <span className="slogan-w2">Forståelig</span> · <span className="slogan-w3">Pålitelig</span></p></div>
          </div>
          <div className="ord-public-head-right">
            <div className={"ord-lang-toggle" + (trLang === "no" ? " is-locked" : "")} role="button" tabIndex={trLang === "no" ? -1 : 0} onClick={() => { if (trLang === 'no') return; const nx = !hideRu; setHideRu(nx); if (!nx && _guestNoTr) setTranslateState('need-login'); }} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (trLang === 'no') return; const nx = !hideRu; setHideRu(nx); if (!nx && _guestNoTr) setTranslateState('need-login'); } }} title={hideRu ? 'Показать русские переводы фраз' : 'Скрыть русские переводы фраз'} aria-label="Переключить язык переводов фраз">
              <span className={"ord-lang-seg" + (!hideRu ? " active" : "")}>{trLang === "no" ? "—" : (trLang || "ru").toUpperCase()}</span>
              <span className={"ord-lang-seg" + (hideRu ? " active" : "")}>NO</span>
            </div>
            <span className="ord-public-title">Ordskjønnhet</span>
          </div>
        </div>
      </header>
      <div className="ord-public-search">
        <div className="ord-public-search-box">
          <svg className="ord-public-search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
          <input type="text" className="ord-public-search-input" value={searchQ} onChange={(e) => setSearchQ(e.target.value)} onClick={() => setSearchFocused((f) => !f)} onBlur={() => setTimeout(() => setSearchFocused(false), 160)} placeholder={trUi("searchPlaceholder")} aria-label={trUi("searchPlaceholder")} />
          <button type="button" className="evik-search-btn ord-public-evik-btn" title="Сгенерировать карточку с ИИ Evik" disabled={evikBusy} onClick={() => { const q = (searchQ || '').trim(); if (!q) return; if (addToHistory) addToHistory(q); if (userProfile && userProfile.id) { onEvik && onEvik(q); } else { setSearchResults([]); setGuestEvikWord(q); } }}>Evik</button>
        </div>
        {searchFocused && !searchQ.trim() && Array.isArray(searchHistory) && searchHistory.length > 0 && (
          <div className="ord-public-search-results ord-public-history-box">
            <div className="ord-public-history-title">{trUi('recentSearches')}</div>
            {searchHistory.map((hw, hi) => (
              <button key={hi} type="button" className="ord-public-history-item" onMouseDown={(e) => { e.preventDefault(); setSearchFocused(false); setSearchQ(''); if (onOpenWord) onOpenWord(hw); }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                <span>{hw}</span>
              </button>
            ))}
          </div>
        )}
        {searchResults.length > 0 && !guestEvikWord && (
          <div className="ord-public-search-results">
            {searchResults.map((r) => (
              <button key={r.word_norm} type="button" onClick={() => { setSearchQ(''); setSearchResults([]); if (addToHistory) addToHistory(r.word_text || r.word_norm); if (onOpenWord) onOpenWord(r.word_text || r.word_norm); }}>{r.word_text || r.word_norm}</button>
            ))}
          </div>
        )}
      </div>
      {guestEvikWord && (
        <div className="ord-public-guest-prompt">
          <button type="button" className="ord-public-guest-close" onClick={() => setGuestEvikWord('')} aria-label="Закрыть">×</button>
          <p>{(guestPromptText || "").replace("{word}", guestEvikWord)}</p>
          <button type="button" className="guest-login-btn ord-public-guest-login" onClick={() => onRequestLogin && onRequestLogin()}>{loginLabel || "Войти"}</button>
        </div>
      )}
      {translateState === 'need-login' && (
        <div className="ord-tr-modal" onClick={() => setTranslateState('dismissed')}>
          <div className="ord-tr-modal-card" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="ord-public-guest-close" onClick={() => setTranslateState('dismissed')} aria-label="Закрыть">×</button>
            <p>{trUi("needLogin")}</p>
            <button type="button" className="guest-login-btn ord-public-guest-login" onClick={() => onRequestLogin && onRequestLogin()}>{loginLabel || 'Войти'}</button>
          </div>
        </div>
      )}
      <div className="ord-public-body">
        {_trPending && translateState !== 'need-login' && translateState !== 'dismissed' && (
          <div className="ord-tr-banner">{trUi('translating')}</div>
        )}
        <button type="button" className="ord-public-close ord-card-close" onClick={onClose} aria-label="Закрыть">×</button>
        {(spinnerHold || versions === null) && (
          <div className="ord-public-loading"><img className="ord-public-spinner" src="/norsk-logo.png" alt="" /></div>
        )}
        {!spinnerHold && versions !== null && versions.length === 0 && (
          <div className="ord-public-empty">
            {err === 'cloud' ? (
              <>
                <p>Не удалось загрузить из облака.</p>
                <p className="ord-pv-muted">Облако временно недоступно — обновите страницу чуть позже.</p>
              </>
            ) : (
              <>
                <p>Публичной страницы для слова «{head}» пока нет.</p>
                <p className="ord-pv-muted">Она появится, когда кто-нибудь подпишет полную версию этого слова.</p>
              </>
            )}
          </div>
        )}
        {!spinnerHold && cur && (
          <div className={"ord-pv" + (animateOpen ? " ord-anim-content" : "")} key={String(wordNorm || "") + "-" + idx}>
            <div className="ord-pv-word">
              {d.type === 'noun' && ['en','ei','et'].includes(d.gender) && (
                <span className="ord-pv-affix" style={{ color }}>{d.gender} </span>
              )}
              {(d.type === 'verb' || (d.type === 'phrase' && Array.isArray(d.forms) && d.forms.length > 0)) && <span className="ord-pv-affix">å </span>}
              <span className="ord-pv-headword" style={(d.type === 'phrase' || _isAdj) ? { color } : undefined}>{head}</span>
              <button type="button" className="ord-pv-tts" onClick={() => speakNorwegian(stripLeadingArticle(head))} aria-label="Прослушать">🔊</button>
            </div>
            {d.phrase && (
              <p className="ord-pv-phrase">{renderPhrase(d.phrase, head, color, d.forms)} <button type="button" className="ord-pv-tts" onClick={() => speakNorwegian(d.phrase, 0.75)} aria-label="Прослушать фразу">🔊</button></p>
            )}
            {!hideRu && dPhraseTr && <p className="ord-pv-phrase-tr">{dPhraseTr}</p>}
            {arr(dTranslations).length > 0 && (
              <div className="ord-pv-tr">{arr(dTranslations).map((t, i) => <span key={i} className="ord-pv-chip">{t}</span>)}</div>
            )}
            {d.photo && (d.photo.thumb || d.photo.dataUrl) && (
              <div className="ord-pv-photo-wrap">
                <div className="ord-pv-photo-frame">
                  <img className="ord-pv-photo" src={d.photo.thumb || d.photo.dataUrl} alt={head} onClick={openZoom} />
                  <div className="ord-pv-photo-brand">
                    <img className="ord-pv-photo-logo" src="/norsk-logo.png" alt="" />
                    <span>Norsk Pro</span>
                  </div>
                </div>
              </div>
            )}
            {(() => {
              const gset = (d.type === 'adjective' && d.grad) ? new Set([d.grad.positiv, d.grad.komparativ, d.grad.superlativ].map((x) => String(x || '').trim()).filter(Boolean)) : null;
              const baseW = String(head || '').trim();
              const isAdj = d.type === 'adjective';
              const formsList = arr(d.forms).map((f) => String(f || '').trim()).filter(Boolean).filter((f) => !(gset && gset.has(f)) && !(isAdj && isComparisonForm(f, baseW)));
              return formsList.length > 0 ? (
                <div className="ord-pv-tr ord-pv-forms">{formsList.map((f, i) => <span key={i} className="ord-pv-chip">{f}</span>)}</div>
              ) : null;
            })()}
            {arr(d.examples).length > 0 && (
              <div className="ord-pv-examples">
                {arr(d.examples).map((ex, i) => (
                  <div key={i} className="ord-pv-example">
                    <p className="ord-pv-ex">{renderPhrase(ex, head, color, d.forms)}</p>
                    {!hideRu && dExampleTr[i] && <p className="ord-pv-ex-tr">{dExampleTr[i]}</p>}
                  </div>
                ))}
              </div>
            )}
            {dStory && <div className="ord-pv-block"><h4>{trUi('story')}</h4><p className="ord-pv-text">{renderPhrase(dStory, head, color, d.forms, true)}</p></div>}
            {arr(d.synonyms).length > 0 && (
              <div className="ord-pv-block"><h4>{trUi('synonyms')}</h4><div className="ord-pv-words">{renderChips(d.synonyms)}</div></div>
            )}
            {arr(d.antonyms).length > 0 && (
              <div className="ord-pv-block"><h4>{trUi('antonyms')}</h4><div className="ord-pv-words">{renderChips(d.antonyms)}</div></div>
            )}
            {d.root && (
              <div className="ord-pv-block"><div className="ord-pv-root-head"><h4>{trUi('root')}</h4><div className="ord-pv-words">{renderChips([d.root])}</div></div>{arr(d.cognates).length > 0 && (<div className="ord-pv-words ord-pv-cognates">{renderChips(d.cognates)}</div>)}</div>
            )}
            {arr(d.phonetic).filter((s) => s && String(s).trim()).length > 0 && (
              <div className="ord-pv-block"><h4>{trUi('phonetic')}</h4><div className="ord-pv-words">{arr(d.phonetic).filter((s) => s && String(s).trim()).map((s, i) => <span key={i} className="ord-pv-word-chip">{String(s).trim()}</span>)}</div></div>
            )}
            {d.type === 'adjective' && d.grad && (d.grad.positiv || d.grad.komparativ || d.grad.superlativ) && (
              <div className="ord-pv-block"><h4>{trUi('comparison')}</h4><div className="ord-pv-words">
                {d.grad.positiv && <span className="ord-pv-word-chip">{d.grad.positiv}</span>}
                {d.grad.komparativ && <span className="ord-pv-word-chip">{d.grad.komparativ}</span>}
                {d.grad.superlativ && <span className="ord-pv-word-chip">{d.grad.superlativ}</span>}
              </div></div>
            )}
            {(d.pos || POS_LABEL[d.type]) && <div className="ord-pv-block"><div className="ord-pv-root-head"><h4>{trUi('pos')}</h4><div className="ord-pv-words"><span className="ord-pv-word-chip">{d.pos ? (d.pos.charAt(0).toUpperCase() + d.pos.slice(1)) : POS_LABEL[d.type]}</span></div></div></div>}
            {d.etymology && <div className="ord-pv-block"><h4>{trUi('etymology')}</h4><p className="ord-pv-text">{boldNo(d.etymology)}</p></div>}
            {cur.fullness_date && <p className="ord-pv-date">{trUi("updated")}: {new Date(cur.fullness_date).toLocaleDateString('ru-RU')}</p>}
            <SongMaker word={head} wordNorm={wordNorm} data={d} userProfile={userProfile} onPersonalCreated={onSongSaved} accentColor={color} uiLang={uiLang} />
          </div>
        )}
        {!spinnerHold && cur && viewCount != null && (
          <p className="ord-pv-views">{viewCount} {viewCount === 1 ? trUi("viewOne") : trUi("viewMany")}</p>
        )}
        {!spinnerHold && cur && cur.owner_nick && (() => {
          const isEvik = String(cur.owner_nick).trim().toLowerCase() === 'evik';
          const isMine = !!(userProfile && ((cur.owner_id && userProfile.id === cur.owner_id) || (!cur.owner_id && cur.owner_nick && userProfile.nickname && String(cur.owner_nick).trim() === String(userProfile.nickname).trim())));
          const ownThumb = (isMine && userProfile.photo && (userProfile.photo.thumb || userProfile.photo.dataUrl)) || null;
          const performerNick = String(cur.owner_nick || '').trim();
          const performerAva = isEvik ? '/evik-avatar.jpg' : ((cur.data && cur.data.ownerAvatar) || ownThumb || null);
          const cust = (cur.data && cur.data.customer) || null;
          const customerNick = (cust && cust.nick) || (isMine ? (userProfile.nickname || null) : null);
          const customerAva = (cust && cust.avatar) || (isMine ? ownThumb : null);
          const samePerson = !isEvik && !!customerNick && String(customerNick).trim() === performerNick;
          const line = (label, nick, ava) => (
            <p className="ord-public-author">
              <span>{label}: {nick}</span>
              {ava ? (
                <img className="ord-author-ava" src={ava} alt={nick} />
              ) : (
                <span className="ord-author-ava ord-author-initial">{String(nick || '?').trim().charAt(0).toUpperCase()}</span>
              )}
            </p>
          );
          const createdAt = cur.created_at || cur.fullness_date || null;
          let dateStr = null;
          if (createdAt) { try { dateStr = new Date(createdAt).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' }); } catch (e) { dateStr = null; } }
          const dateLine = dateStr ? (<p className="ord-public-created">{trUi("created")}: {dateStr}</p>) : null;
          if (samePerson) {
            return (<>{<div className="ord-public-credits">{line(trUi('customerPerformer'), performerNick, performerAva || customerAva)}</div>}{dateLine}</>);
          }
          return (
            <>
              <div className="ord-public-credits">
                {customerNick ? line(trUi('customer'), customerNick, customerAva) : null}
                {line(trUi('performer'), performerNick, performerAva)}
              </div>
              {dateLine}
            </>
          );
        })()}
        {!spinnerHold && cur && (
          <div className="ord-public-share">
            <button type="button" className={"btn-std ord-public-copy" + (copied ? " is-copied" : "")} onClick={copyLink}>{copied ? trUi('copied') : trUi('copyLink')}</button>
          </div>
        )}
        {err && <p className="ord-public-info">{err}</p>}
      </div>
      {zoom && (
        <div className="ord-photo-zoom" onClick={() => setZoom(false)}>
          <div className="ord-photo-zoom-card" onClick={(e) => e.stopPropagation()}>
            {fullPhoto && (
              <img src={fullPhoto} alt={head} onLoad={() => setImgReady(true)} style={{ display: imgReady ? 'block' : 'none' }} />
            )}
            {!imgReady && <div className="ord-photo-zoom-spinner" aria-label="Загрузка" />}
            <button type="button" className="ord-photo-zoom-close" onClick={(e) => { e.stopPropagation(); setZoom(false); }} aria-label="Закрыть">×</button>
          </div>
        </div>
      )}
    </div>
  );
}
